module.exports = __webpack_public_path__ + "media/images/client-11-cc4be05b7ffa081384e92c6fa228b910.png";